
import Spacing from 'components/Spacing';
import { VStack } from 'components/Stack';
import { Banner } from 'container/common/Banner';

import Footer from 'container/common/Footer';
import Header from 'container/common/Header';
import { LanguagePicker } from 'container/common/LanguagePicker';
import SectionA from 'container/landing/SectionA';
import SectionB from 'container/landing/SectionB';
import SectionC from 'container/landing/SectionC';
import SectionD from 'container/landing/SectionD';
import SectionE from 'container/landing/SectionE';

import { useNavigate } from 'react-router';
import styled from 'styled-components';

const Landing = () => {
  const navigate = useNavigate();
  const handleClickBook = () => navigate('/book');

  return (
    <VStack $width='100%'>
      <Header right={<LanguagePicker />} />
      <Container>
        <SectionA onClickBook={handleClickBook} />
        <Banner />
        <SectionB onClickBook={handleClickBook} />
        <SectionC onClickBook={handleClickBook} />
        <SectionD onClickBook={handleClickBook} />
        <SectionE onClickBook={handleClickBook} />
      </Container>
      <Spacing />
      <Footer />
    </VStack>
  );
};

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

export default Landing;
